import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQrcode,
  faClock,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const dummyLogs = [
  {
    id: "LOG-001",
    appointmentId: "GAS-APT-001",
    agenda: "Vendor Discussion",
    scannedAt: "10:05 AM",
    entryType: "Scheduled",
    location: "Mumbai HQ",
  },
  {
    id: "LOG-002",
    appointmentId: "WALK-002",
    agenda: "Client Walk-in",
    scannedAt: "01:42 PM",
    entryType: "Walk-in",
    location: "Reception Desk",
  },
  {
    id: "LOG-003",
    appointmentId: "GAS-APT-004",
    agenda: "Investor Meeting",
    scannedAt: "03:10 PM",
    entryType: "Scheduled",
    location: "Conference Room",
  },
];

const GASLog = () => {
  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h1 className="text-xl font-semibold mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faQrcode} />
        <span>Scan Logs</span>
      </h1>

      {dummyLogs.map((log) => (
        <div
          key={log.id}
          className="border border-cyan-800 rounded-xl p-4 mb-4"
        >
          <h2 className="font-semibold text-sm">{log.agenda}</h2>

          <div className="text-xs text-gray-400 mt-1">
            Appointment ID: {log.appointmentId}
          </div>

          <div className="flex justify-between mt-3 text-xs">
            <span className="flex items-center gap-1">
              <FontAwesomeIcon icon={faClock} />
              {log.scannedAt}
            </span>

            <span className="text-cyan-300">{log.entryType}</span>
          </div>

          <div className="flex items-center gap-1 text-xs text-gray-400 mt-2">
            <FontAwesomeIcon icon={faLocationDot} />
            {log.location}
          </div>
        </div>
      ))}

      {dummyLogs.length === 0 && (
        <p className="text-sm text-gray-500">No scan logs available.</p>
      )}
    </div>
  );
};

export default GASLog;
